export interface IShortKey {
  id?: string; // short key id will only be added when bind key to help tracking different short key events
  keys: string[];
  callback: () => void;
}

/* const keyCodes = {
  65: 'a',
  66: 'b',
  67: 'c',
  68: 'd',
  69: 'e',
  70: 'f',
  71: 'g',
  72: 'h',
  73: 'i',
  74: 'j',
  75: 'k',
  76: 'l',
  77: 'm',
  78: 'n',
  79: 'o',
  80: 'p',
  81: 'q',
  82: 'r',
  83: 's',
  84: 't',
  85: 'u',
  86: 'v',
  87: 'w',
  88: 'x',
  89: 'y',
  90: 'z',
}; */

const createShortcutIndex = (pKey: KeyboardEvent) => {
  let k = '';
  if (pKey.key === 'Shift' || pKey.shiftKey) { k += 'shift'; }
  if (pKey.key === 'Control' || pKey.ctrlKey) { k += 'ctrl'; }
  if (pKey.key === 'Meta' || pKey.metaKey) { k += 'meta'; }
  if (pKey.key === 'Alt' || pKey.altKey) { k += 'alt'; }
  if (pKey.key === 'ArrowUp') { k += 'arrowup'; }
  if (pKey.key === 'ArrowLeft') { k += 'arrowleft'; }
  if (pKey.key === 'ArrowRight') { k += 'arrowright'; }
  if (pKey.key === 'ArrowDown') { k += 'arrowdown'; }
  if (pKey.key === 'AltGraph') { k += 'altgraph'; }
  if (pKey.key === 'Escape') { k += 'esc'; }
  if (pKey.key === 'Enter') { k += 'enter'; }
  if (pKey.key === 'Tab') { k += 'tab'; }
  if (pKey.key === ' ') { k += 'space'; }
  if (pKey.key === 'PageUp') { k += 'pageup'; }
  if (pKey.key === 'PageDown') { k += 'pagedown'; }
  if (pKey.key === 'Home') { k += 'home'; }
  if (pKey.key === 'End') { k += 'end'; }
  if (pKey.key === 'Delete') { k += 'del'; }
  if (pKey.key === 'Backspace') { k += 'backspace'; }
  if (pKey.key === 'Insert') { k += 'insert'; }
  if (pKey.key === 'NumLock') { k += 'numlock'; }
  if (pKey.key === 'CapsLock') { k += 'capslock'; }
  if (pKey.key === 'Pause') { k += 'pause'; }
  if (pKey.key === 'ContextMenu') { k += 'contextmenu'; }
  if (pKey.key === 'ScrollLock') { k += 'scrolllock'; }
  if (pKey.key === 'BrowserHome') { k += 'browserhome'; }
  if (pKey.key === 'MediaSelect') { k += 'mediaselect'; }
  if (pKey.key === '=') { k += '='; }
  if (pKey.key === '-') { k += '-'; }
  if (pKey.key === '+') { k += '+'; }
  if (pKey.key === '!' || pKey.key === '1') { k += '!'; }
  if (pKey.key === ')' || pKey.key === '0') { k += ')'; }
  // if (pKey.key === '[') { k += '['; }
  // if (pKey.key === ']') { k += ']'; }
  if (pKey.code === 'BracketLeft') { k += '['; }
  if (pKey.code === 'BracketRight') { k += ']'; }
  if ((pKey.code && pKey.code !== ' ') && /^Key/.test(pKey.code)) k += pKey.code.replace(/Key/, '').toLowerCase();
  return k;
};

let shouldHandleKeyDown = '';
let keyList = [];
let keyId = 0;

export const bindShortKeys = (keys: IShortKey[]) => {
  const keysWithId = keys.map((key) => {
    keyId += 1;
    return { ...key, id: keyId };
  });
  keyList = [...keyList, ...keysWithId];

  const shortKeyCommand = (evt: KeyboardEvent) => {
    if (['text'].includes((evt.target as HTMLInputElement)?.dataset?.type)) return;
    if (['input', 'textarea', 'text', 'search'].includes((evt.target as HTMLInputElement).type)) return;
    const key = createShortcutIndex(evt);
    if (evt.repeat || key === shouldHandleKeyDown) return;
    evt.preventDefault();
    shouldHandleKeyDown = key;
    const cmd = keyList.find((n) => n.keys.join('') === key);
    if (cmd && cmd.callback) cmd.callback();
  };

  const shortKeyUpCommand = () => {
    shouldHandleKeyDown = '';
  };

  document.addEventListener('keydown', shortKeyCommand, true);
  document.addEventListener('keyup', shortKeyUpCommand, true);

  const removeShortKeys = () => {
    keysWithId.forEach((key) => {
      keyList = keyList.filter((o) => o.id !== key.id);
    });
    document.removeEventListener('keydown', shortKeyCommand, true);
    document.removeEventListener('keyup', shortKeyUpCommand, true);
  };

  return removeShortKeys;
};

export default bindShortKeys;
